import type { ChainInfo, } from "../../types";


export const arbitrum: ChainInfo = {
	name: "arbitrum",
	chainId: 42161,
	icon: "/assets/arbitrum.svg",
	label: "Arbitrum",
}
